import * as React from "react";
import Grid from "@mui/material/Grid/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography/Typography";
import Box from "@mui/material/Box/Box";
import Skeleton from "@mui/material/Skeleton/Skeleton";
import firebase from "../firebase/firebase";
import {useNavigate} from "react-router-dom";
import {AuthUserContext} from "../providers/AuthProvider";


// Create a reference to the file we want to download
import CloseIcon from '@mui/icons-material/Close';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

const storageRef = firebase.storage().ref();
function ArtistListItemNew({ title, genre, posted, location, image, id}) {
  const { profile} = React.useContext(AuthUserContext)
  const [imageUrl, setImageUrl] = React.useState()
  const [loading, setLoading] = React.useState(true)
  const navigator = useNavigate()
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  React.useEffect(()=> {
    if (image && image !== '') {
      const starsRef = storageRef.child(image);

// Get the download URL
      starsRef.getDownloadURL()
        .then((url) => {
          setImageUrl(url)
          setLoading(false)
          // Insert url into an <img> tag to "download"
        })
        .catch((error) => {
          setLoading(false)

          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case 'storage/object-not-found':
              // File doesn't exist
              break;
            case 'storage/unauthorized':
              // User doesn't have permission to access the object
              break;
            case 'storage/canceled':
              // User canceled the upload
              break;

            // ...

            case 'storage/unknown':
              // Unknown error occurred, inspect the server response
              break;
          }
        });
    }
  }, [])


  const listItem = {
    display : "flex",
    flexDirection : "row",
    justifyContent : "space-between",
  }
    
  
  return(
    
    <Box sx={{ width: '100%', border:'1px solid #204488', borderRadius: '14px',p: 3 , marginTop:"24px" ,'&:hover': {backgroundColor: '#204488',color: '#fff',},cursor:"pointer" }}
        onClick={() => profile && !profile?.membership ? setOpen(true) : navigator(`/creator/artist-details/${id}`)
    }>
      <Stack    direction={{ xs: 'column', md:'row' }}
                justifyContent={{ xs: 'center',md:'flex-start' }}
                alignItems={{ xs: 'flex-start',md:'center' }}
                spacing={3}
                // style={ { justifyContent : "space-between"}}
                >
            
            {loading ? <Skeleton variant="rectangular" sx={{ bgcolor: '#ccc', borderRadius:'14px', height: "100px" ,width:'100px'}} />:
                            <img style={{height: "100px", width:'100px', objectFit:'cover',borderRadius: '14px'}}
                            src={imageUrl}  alt=""/>
            }
            <Stack  direction="column"
                    justifyContent="center"
                    alignItems="space-between"
                    spacing={1}>
                <Typography variant={'h6'}  sx={{width:'300px'}}>
                    {title}
                </Typography>
                <Typography variant={'body2'} sx={{fontSize:'13'}} color={'secondary'}>
                    Posted: {posted}
                </Typography>
            </Stack>

            

            <Stack  direction="column"
                    justifyContent="center"
                    alignItems="space-between"
                    spacing={2} sx={{width:'300px'}}>
                <Typography variant={'body1'}  noWrap={true} sx={{fontSize:14}}  >
                    Location: {location}
                </Typography>
                <div style={{flex:1}}/>
                <Typography variant="body1" noWrap={true}  sx={{fontSize:14}} >
                    Skills: {genre && genre.length > 0 && genre?.map && genre.map((d) => (`${d}, `))}
                </Typography>
            </Stack>
            
            <Stack direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}
                sx={{
                flex: 1
                }}>
                    <FavoriteBorderIcon />
          </Stack>

      </Stack>
    </Box>

  )
}
export default ArtistListItemNew;

